import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import interactionPlugin from '@fullcalendar/interaction'; // needed for dayClick
import FullCalendar from '@fullcalendar/react';
import clsx from 'clsx';
import moment from 'moment/moment';
import React, { useEffect, useRef, useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CalendarIcon } from '../../Assets/icons';
import Header from '../../Components/General/Header';
import LayoutComponent from '../../Components/General/LayoutComponent';
import Button from '../../Components/UI/Button';
import Loader from '../../Components/UI/Loader';
import PaddingContainer from '../../Components/UI/PaddindContainer';
import { isMobileViewHook } from '../../CustomHooks/isMobileViewHook';
import CreateAppointmentDrawer from '../../Drawer/ScheduleDrawer/CreateAppointmentDrawer';
import PatientInformationDrawer from '../../Drawer/ScheduleDrawer/PatientInformation';
import ScheduleListDrawer from '../../Drawer/ScheduleDrawer/ScheduleListDrawer';
import useAppointment from '../../Features/useAppointment';
import useDoctor from '../../Features/useDoctor';
import { appointmentDateRange, eventOrderCustom } from '../../Helpers';
import { setScheduleDate } from '../../Store/commonSlice';
import classes from './Appointements.module.css';
const Appointments = () => {
  const { getAllServicesListing } = useDoctor();
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const appointmentList = useSelector((state) => state?.commonReducer?.appointmentList);

  const { getAllAppointments, loading } = useAppointment();
  const [showAppointmentDrawer, setShowAppointmentDrawer] = useState(false);
  const calendarRef = useRef(null);
  const [showScheduleListDrawer, setShowScheduleListDrawer] = useState(false);
  const [monthTitle, setMonthTitle] = useState('');
  const [selectedEventList, setSelectedEventList] = useState([]); // Store selected event details
  const [selectedDate, setSelectedDate] = useState('');
  const [showSingleAppointmentDetail, setShowSingleAppointmentDetail] = useState(false);
  const [personalInformation, setPersonalInformation] = useState(null);
  const handleNext = () => {
    const calendarApi = calendarRef.current.getApi();
    calendarApi.next();
    updateMonthTitle(calendarApi);
  };
  const toggleSingleAppointmentDetail = () => {
    setShowSingleAppointmentDetail((prev) => !prev);
  };
  const handlePrev = () => {
    const calendarApi = calendarRef.current.getApi();
    calendarApi.prev();
    updateMonthTitle(calendarApi);
  };
  const updateMonthTitle = (calendarApi) => {
    const title = calendarApi
      .getDate()
      .toLocaleString('default', { month: 'long', year: 'numeric' });
    setMonthTitle(title);
  };
  useEffect(() => {
    const calendarApi = calendarRef.current.getApi();
    updateMonthTitle(calendarApi);
  }, []);

  /* */
  const toggleAppointmentDrawer = () => {
    setShowAppointmentDrawer((currentState) => !currentState);
  };
  const sortedAppointments = (appointments) => {
    return [...appointments].sort((a, b) => {
      // Handle deleted status - isDeleted: false should go last
      if (a.isDeleted && !b.isDeleted) {
        return 1;
      }
      // If a isDeleted is false and b isDeleted is true, a should come before b
      if (!a.isDeleted && b.isDeleted) {
        return -1;
      }
      // If both have the same isDeleted value, maintain their current order
      return 0;
    });
  };
  const handleDateClick = (info) => {
    // Find events on the clicked date
    toggleScheduleListDrawer();
    const formattedDate = moment(info?.dateStr).format('DD MMMM YYYY');
    dispatch(setScheduleDate(formattedDate));
    const eventsOnDate = appointmentList.filter(
      (event) => event.start === info.dateStr || event.end === info.dateStr
    );
    if (Array.isArray(eventsOnDate)) setSelectedEventList(eventsOnDate.sort(eventOrderCustom));
    setSelectedDate(moment(info.dateStr).format('DD-MM-YYYY')); // Debug log
  };
  const toggleScheduleListDrawer = () => {
    setShowScheduleListDrawer((prev) => !prev);
  };
  const handleEventClick = (info) => {
    console.log('Event clicked:', info); // Debug log
    setPersonalInformation(info.event?._def?.extendedProps);
    toggleSingleAppointmentDetail();
  };


  useEffect( () => {
    (async () => {
      await Promise.allSettled([
        getAllAppointments(appointmentDateRange()),
        getAllServicesListing()
      ]);
    })();
  }, []);

  useEffect(() => {
    isMobileViewHook(setIsMobile, 767);
  }, []);
  const onNext = () => {
    navigate('/settings');
  };
  const onPrev = () => {
    navigate('/dashboard');
  };
  const handleMoreLinkClick = (arg) => {
    // You can customize this to show a modal or handle it differently
    return true; // Return true to use the default behavior (shows events in a popover)
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <style>
            {`
          .fc .fc-daygrid-day.fc-day-today div a.fc-daygrid-day-number {
            color: #fff !important;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            background-color: var(--primary-color);
          }
          .fc-h-event {
            border-radius: 0 !important;
          }
          .fc-event.fc-event-start {
            border-radius: 30px !important;
            text-align: center;
          }
          .fc .fc-toolbar {
            justify-content: start;
          }
          .fc-header-toolbar {
            position: relative !important;
            width: 300px;
          }
          .fc-button-group {
            position: initial !important;
          }
          .fc-event-start {
            border-radius: 50px !important;
            overflow: hidden !important;
            display: flex;
            justify-content: center;
          }
          .fc-h-event {
            border: 0px solid !important;
          }
          .fc .fc-toolbar.fc-header-toolbar {
            display:none;
          }
        `}
          </style>
          <LayoutComponent>
            <Header title="Schedule" onNext={onNext} onPrev={onPrev} />
            <PaddingContainer>
              <ul className={classes.actonHeader}>
                <li>
                  <div className={classes.navigationWrapper}>
                    <button className="transparent-button" onClick={handlePrev}>
                      <FaChevronLeft color="var(--icon-color)" />
                    </button>
                    <span className={classes.monthTitle}>{monthTitle}</span>
                    <button onClick={handleNext} className="transparent-button">
                      <FaChevronRight color="var(--icon-color)" />
                    </button>
                  </div>
                </li>
                <li>
                  <Button
                    leftIcon={<CalendarIcon color="var(--primary-color)" />}
                    variants="view"
                    label="Create Appointment"
                    className={classes.calendarButton}
                    onClick={toggleAppointmentDrawer}
                  />
                </li>
              </ul>
              <div className={clsx(classes.calenderWrapper, 'scrollbar1')}>
                <FullCalendar
                  ref={calendarRef}
                  plugins={[dayGridPlugin, interactionPlugin]}
                  initialView="dayGridMonth"
                  firstDay={1}
                  locale="en"
                  events={sortedAppointments(appointmentList)}
                  dateClick={handleDateClick}
                  eventClick={handleEventClick}
                  moreLinkClick={handleMoreLinkClick}
                  dayMaxEvents={isMobile ? 2 : 4}
                  moreLinkText={(n) => `+${n} more`}
                  eventDisplay="block"
                  eventClassNames="text-sm"
                  dayCellClassNames="hover:bg-gray-50"
                  headerToolbar={{
                    left: 'prev,next today',
                    center: 'title',
                    right: ''
                  }}
                  eventOrder={eventOrderCustom}
                  displayEventEnd={true}
                  eventTimeFormat={{
                    hour: '2-digit',
                    minute: '2-digit',
                    meridiem: false
                  }}
                />
              </div>
            </PaddingContainer>
          </LayoutComponent>
          <ScheduleListDrawer
            show={showScheduleListDrawer}
            setShow={toggleScheduleListDrawer}
            data={[...selectedEventList]}
            date={selectedDate}
          />
          <CreateAppointmentDrawer show={showAppointmentDrawer} setShow={toggleAppointmentDrawer} />
          <PatientInformationDrawer
            data={{ ...personalInformation }}
            show={showSingleAppointmentDetail}
            setShow={toggleSingleAppointmentDetail}
          />
        </>
      )}
    </>
  );
};

export default Appointments;
